import { Alphanumeric, Byte, Charset, Encoder, Hanzi, Kanji, Numeric } from "@nuintun/qrcode";
function hex2rgb(hex) {
  const value = parseInt(hex.slice(1, 7), 16);
  return [value >> 16 & 255, value >> 8 & 255, value & 255];
}
function getHints({ fnc1, aimIndicator }) {
  switch (fnc1) {
    case "GS1":
      return { fnc1: ["GS1"] };
    case "AIM":
      return { fnc1: ["AIM", +aimIndicator] };
  }
}
function chooseBestMode({ mode, content, charset }) {
  switch (mode) {
    case "Auto":
      const NUMERIC_RE = /^\d+$/;
      const ALPHANUMERIC_RE = /^[0-9A-Z$%*+-./: ]+$/;
      if (NUMERIC_RE.test(content)) {
        return new Numeric(content);
      }
      if (ALPHANUMERIC_RE.test(content)) {
        return new Alphanumeric(content);
      }
      const hanzi = new Hanzi(content);
      try {
        hanzi.encode();
        return hanzi;
      } catch (e) {
      }
      const kanji = new Kanji(content);
      try {
        kanji.encode();
        return kanji;
      } catch (e) {
      }
      return new Byte(content, Charset[charset]);
    case "Hanzi":
      return new Hanzi(content);
    case "Kanji":
      return new Kanji(content);
    case "Numeric":
      return new Numeric(content);
    case "Alphanumeric":
      return new Alphanumeric(content);
    default:
      return new Byte(content, Charset[charset]);
  }
}
class QRCode {
  constructor(dom, options) {
    this.dom = dom;
    this.options = options;
  }
  makeCode(content) {
    const { colorDark = "#000000", useSVG, correctLevel, mode = 4 } = this.options;
    const data = {
      level: correctLevel,
      version: void 0,
      content,
      mode,
      charset: "UTF-8",
      moduleSize: 2,
      quietZone: 1,
      background: "#FFFFFF",
      foreground: colorDark
    };
    const encoder = new Encoder({
      level: data.level,
      version: data.version,
      hints: getHints(data)
    });
    try {
      const qrcode = encoder.encode(chooseBestMode(data));
      const { moduleSize, quietZone, background, foreground } = data;
      const dataURL = qrcode.toDataURL(moduleSize, {
        margin: quietZone,
        background: hex2rgb(background),
        foreground: hex2rgb(foreground)
      });
      const img = document.createElement("img");
      img.src = dataURL;
      img.style.width = "100%";
      img.style.height = "100%";
      this.dom.innerHTML = "";
      this.dom.appendChild(img);
    } catch (error) {
      console.error("QRCode generation error:", error);
      this.dom.innerHTML = "\u4E8C\u7EF4\u7801\u751F\u6210\u5931\u8D25";
    }
  }
}
export {
  QRCode as default
};
